export const CE_SCREEN_OPEN = "CE_SCREEN_OPEN";
export const CE_SCREEN_CLOSE = "CE_SCREEN_CLOSE";
export const CE_SCREEN_UPDATE_STATE = "CE_SCREEN_UPDATE_STATE";

export const ceScreenUpdateState = (state) => ({
  type: CE_SCREEN_UPDATE_STATE,
  state: state,
});

export const ceScreenClose = () => ({
  type: CE_SCREEN_CLOSE,
});
